































import { Component, Vue } from 'vue-property-decorator';
import Drawer from '@/components/Drawer.vue';
import TokenService from '../services/token';
import router from '../router';
@Component({
  components: {
    Drawer,

  },
})
export default class Dashboard extends Vue {
  private tokenService: TokenService;

  constructor() {
    super();
    this.tokenService = new TokenService();
  }


  public async logout() {
    router.push({name: 'login'} );
    await this.tokenService.axiosLogout();

  }
}
